const cleanPhone = <T extends string | null>(value: T): T => {
  if (!value) {
    return value
  }
  return value.replace(/[^\d]/g, '') as T
}

export default cleanPhone
